import React from "react";
import { connect } from "react-redux";
import DonateWidget from "../../molecules/donate/donate-widget";
import donationContent from "./donationContent.json";

import "./supportPage.m.css";

const SupportPageView = () => {
  return (
    <div styleName="static-container">
      <h1 styleName="main-headline">Support Us</h1>
      <div styleName="content-wrapper">
        <div styleName="left-side">
          {donationContent.map((section, index) => (
            <div styleName="block-wrapper" key={index}>
              {section.title && (
                <div styleName="sub-title-wrapper">
                  <h2 styleName="sub-title">{section.title}</h2>
                </div>
              )}
              {section.paragraphs.map((text, i) => (
                <p styleName="paragraph" key={i}>
                  {text}
                </p>
              ))}
              {section.listItems.length > 0 && (
                <ol styleName="ordered-list">
                  {section.listItems.map((item, i) => (
                    <li styleName="list-item" key={i}>
                      {item}
                    </li>
                  ))}
                </ol>
              )}
            </div>
          ))}
        </div>
        <div styleName="right-side">
          <DonateWidget />
        </div>
      </div>
    </div>
  );
};

const SupportPage = connect(null)(SupportPageView);

export { SupportPage };
